var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionManager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z",
    stroke: "#313131",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5701 18.5V14.6M15.5701 7.45V5.5M15.5701 7.45C15.9115 7.45 16.2496 7.51725 16.5651 7.64791C16.8805 7.77858 17.1671 7.97009 17.4086 8.21152C17.65 8.45295 17.8415 8.73958 17.9722 9.05502C18.1028 9.37047 18.1701 9.70856 18.1701 10.05C18.1701 10.3914 18.1028 10.7295 17.9722 11.045C17.8415 11.3604 17.65 11.647 17.4086 11.8885C17.1671 12.1299 16.8805 12.3214 16.5651 12.4521C16.2496 12.5827 15.9115 12.65 15.5701 12.65C14.8805 12.65 14.2192 12.3761 13.7316 11.8885C13.244 11.4009 12.9701 10.7396 12.9701 10.05C12.9701 9.36044 13.244 8.69912 13.7316 8.21152C14.2192 7.72393 14.8805 7.45 15.5701 7.45ZM8.43008 18.5V16.55M8.43008 16.55C8.77152 16.55 9.10961 16.4827 9.42506 16.3521C9.7405 16.2214 10.0271 16.0299 10.2686 15.7885C10.51 15.547 10.7015 15.2604 10.8322 14.945C10.9628 14.6295 11.0301 14.2914 11.0301 13.95C11.0301 13.6086 10.9628 13.2705 10.8322 12.955C10.7015 12.6396 10.51 12.353 10.2686 12.1115C10.0271 11.8701 9.7405 11.6786 9.42506 11.5479C9.10961 11.4173 8.77152 11.35 8.43008 11.35C7.74052 11.35 7.07919 11.6239 6.5916 12.1115C6.10401 12.5991 5.83008 13.2604 5.83008 13.95C5.83008 14.6396 6.10401 15.3009 6.5916 15.7885C7.07919 16.2761 7.74052 16.55 8.43008 16.55ZM8.43008 9.4V5.5",
    stroke: "#313131",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionManager);
export default __webpack_public_path__ + "static/media/question-manager.cc25261dd0f0d4ec66451d503366dcc9.svg";
export { ForwardRef as ReactComponent };